// import components
import styled from 'styled-components';

// import constants
import { PRIMARY } from 'constants/colors';

// import utils
import { brightness } from 'utils/misc';

export default styled.div`
  .contact {
    border: 1px solid ${PRIMARY};
    border-radius: 4px;
    background-color: ${brightness(PRIMARY, 90)};
    padding: 14px 20px;
    position: relative;

    + .contact {
      margin-top: 10px;
    }

    .name {
      width: 330px;
      flex-shrink: 0;
      font-size: 16px;
      font-family: 'SourceSansPro-Bold';
    }

    .phone-email {
      width: 200px;
      flex-shrink: 0;
    }

    .remarks {
      width: 200px;
    }

    .contact-actions {
      margin-left: 30px;
      flex-grow: 1;
    }
  }
`;
